module.exports = __webpack_public_path__ + "img/Background_Vision_Mission.6867a919.png";